import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ssc-contact-banner',
  templateUrl: './contact-banner.component.html',
  styleUrls: ['./contact-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactBannerComponent {
  public showContactOverlay = false;
}
